import React, { useState } from 'react';
import styled from 'styled-components';
import { ScreenSize, useScreenSize } from '../../contexts/ScreenSizeContext';
import Hamburger from '../molecules/Hamburger';

const Header = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
  background-color: ${({ theme }) => theme.backgroundMid || '#ffffff'};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.1);
  z-index: 1000;
`;

const Title = styled.div`
  font-size: 1.5rem;
`;

const NavLinks = styled.nav`
  display: flex;
  gap: 1rem;
  align-items: center;

  /* Hide nav links on mobile */
  @media (max-width: 600px) {
    display: none;
  }
`;

interface HeaderLinkProps {
  $screenSize?: ScreenSize;
}

const HeaderLink = styled.a<HeaderLinkProps>`
  color: ${({ theme }) => theme.fontColor || '#ffffff'};
  font-size: 1rem;
  font-weight: 600;
  text-decoration: none;
  margin-top: ${({ $screenSize }) =>
    $screenSize === 'mobile' ? '2rem' : '0'};
  &:hover {
    color: ${({ theme }) => (theme ? theme.onHover : '#ffffff')};
  }
`;

const MobileMenu = styled.div<{ $open: boolean }>`
  border: 1px solid hsla(0, 0%, 0%, 0);
  border-radius: 0 0 0 15px;
  display: ${({ $open }) => ($open ? 'flex' : 'none')};
  flex-direction: column;
  position: absolute;
  top: 55px;
  right: 0;
  background-color: #27272a;
  padding: 1rem 3rem 3rem 3rem;
  z-index: 9999;
`;

const ButtonsContainer = styled.div`
  display: flex;
`;

const HeaderBar: React.FC = () => {
  const { screenSize } = useScreenSize();
  const [menuOpen, setMenuOpen] = useState(false);

  // const toggleMenu = () => setMenuOpen((prev) => !prev);

  const toggleMenu = () => setMenuOpen((prev) => !prev);

  return (
    <Header>
      <Title>James Scott</Title>

      {screenSize === 'mobile' ? (
        <>
          {/* <HamburgerButton onClick={toggleMenu}>
            <Bar />
            <Bar />
            <Bar />
          </HamburgerButton> */}

          <MobileMenu $open={menuOpen}>
            <HeaderLink
              href=""
              $screenSize={screenSize}
              onClick={() => toggleMenu()}
            >
              Home
            </HeaderLink>
            <HeaderLink
              href="#projects"
              $screenSize={screenSize}
              onClick={() => toggleMenu()}
            >
              Projects
            </HeaderLink>
            <HeaderLink
              href="#skills"
              $screenSize={screenSize}
              onClick={() => toggleMenu()}
            >
              Skills
            </HeaderLink>
          </MobileMenu>
        </>
      ) : (
        <NavLinks>
          <HeaderLink href="">Home</HeaderLink>
          <HeaderLink href="#projects">Projects</HeaderLink>
          <HeaderLink href="#skills">Skills</HeaderLink>
        </NavLinks>
      )}

      <ButtonsContainer>
        <Hamburger toggleMenu={toggleMenu} />
        {/* <DarkModeToggleContainer onClick={toggleTheme}>
          <DarkModeToggle />
        </DarkModeToggleContainer> */}
      </ButtonsContainer>
    </Header>
  );
};

export default HeaderBar;
